import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "modal-dialog modal-dialog-centered modal-dialog-scrollable" }
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = {
  class: "modal-title fw-bold",
  id: "exampleModalLabel"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close bg-info text-light rounded-pill px-3 opacity-100",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "modal-footer" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  key: 0,
  class: "fa fa-spinner fa-spin",
  "aria-hidden": "true"
}

import { toast } from "vue3-toastify";
import { impalaApi } from "@/main.ts";
import { ref, onMounted, reactive } from "vue";
import BaseInput from "@/components/base-components/BaseInputPill.vue";


const __default__ = {
  name: "SendMailModal",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const mailModal = ref();
const title = ref<string>();
const projectId = ref<string>();
const loading = ref(false);

let form = reactive({
  email: "",
  resultsIds: "",
});

onMounted(() => {
  mailModal.value.addEventListener("show.bs.modal", (event) => {
    title.value = event.relatedTarget.getAttribute("data-bs-title");
    form.resultsIds = JSON.parse(
      event.relatedTarget.getAttribute("data-bs-results")
    );
    projectId.value = event.relatedTarget.getAttribute("data-bs-projectId");
  });
});

const submit = async () => {
  try {
    loading.value = true;
    let response = await impalaApi.post(
      `client-dashboard/projects/${projectId.value}/aggregate-results`,
      form
    );
    toast.success("Email sent successfully!");
    form.email = "";
  } catch (error: never) {
    toast.error("Failed: There was an error, the email wasn't sent");
    console.log(error.response?.data);
  } finally {
    loading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "mailModal",
    ref: mailModal,
    class: "modal fade",
    id: "sendMailModal",
    tabindex: "-1",
    "aria-labelledby": "exampleModalLabel",
    "aria-hidden": "true",
    "data-bs-touch": "false",
    "data-bs-interval": "false"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("form", {
        onSubmit: _withModifiers(submit, ["prevent"]),
        role: "form",
        class: "ui form modal-content bg-light rounded-card px-3 px-sm-3 py-3"
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h5", _hoisted_4, _toDisplayString(title.value), 1),
          _hoisted_5
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(BaseInput, {
            value: _unref(form).email,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).email) = $event)),
            name: "email",
            type: "email",
            id: "email-sign-up",
            "aria-placeholder": "E-mail",
            placeholder: "E-mail",
            required: ""
          }, null, 8, ["value"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            disabled: loading.value,
            type: "submit",
            class: "btn btn-primary text-light rounded-pill px-5 py-1"
          }, [
            _createTextVNode(" Send "),
            (loading.value)
              ? (_openBlock(), _createElementBlock("i", _hoisted_9))
              : _createCommentVNode("", true)
          ], 8, _hoisted_8)
        ])
      ], 40, _hoisted_2)
    ])
  ], 512))
}
}

})